export default "__VITE_ASSET__DF5C7HOt__"